export const generateYearList = () => {
  const thisYear = new Date().getFullYear();
  return Array(10)
    .fill()
    .map((_, index) => thisYear - 4 + index);
};
